var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-steps"},[_c('div',{staticClass:"steps-title"},_vm._l((_vm.maxSteps),function(step){return _c('span',{key:step.id,staticClass:"step",class:{ active: _vm.$store.getters.getCurrentStep + 1 === step }},[_vm._v("\n        "+_vm._s(step)+"\n    ")])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13c6f528","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/userProfile/UserProfileSteps.vue
// module id = null
// module chunks = 